<script setup lang="ts">
import type { EditorialStatus } from '../types'
import { statusLabels } from '../lib/format'
defineProps<{ status: EditorialStatus }>()
</script>
<template><span class="status-badge" :data-status="status"><span aria-hidden="true">●</span>{{ statusLabels[status] }}</span></template>
